import dayjs from 'dayjs';
import 'dayjs/locale/nl';

const euro = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
const euroRound = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

export const formatEuro = (value, { round = false } = {}) => {
  if (value === null || value === undefined || value === '') return '';
  const number = Number(value);
  if (Number.isNaN(number)) return '';
  return (round ? euroRound : euro).format(number);
};

export const formatMonth = (iso) => {
  if (!iso) return '';
  const date = dayjs(iso);
  return date.isValid() ? date.locale('nl').format('MMMM YYYY') : iso;
};

export const monthKey = (iso) => (iso ? String(iso).slice(0, 7) : '');

export const todayIso = () => dayjs().format('YYYY-MM-DD');

export const parseAmount = (text) => {
  const clean = String(text ?? '').trim().replace(/[€\s]/g, '');
  if (clean === '') return null;

  let normal = clean;
  if (clean.includes(',')) {
    normal = clean.replace(/\./g, '').replace(',', '.');
  } else if (/^\d{1,3}(\.\d{3})+$/.test(clean)) {
    normal = clean.replace(/\./g, '');
  }

  return /^\d+(\.\d+)?$/.test(normal) ? Number(normal) : NaN;
};

export const amountInput = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const number = Number(value);
  if (Number.isNaN(number)) return '';
  return number.toFixed(2).replace(/\.00$/, '').replace('.', ',');
};

export const sortByName = (list) =>
  [...list].sort((a, b) => (a.name || '').localeCompare(b.name || '', 'nl'));

export const sortServices = (list) => {
  const sorted = sortByName(list);
  const dotted = (item) => (item.name || '').startsWith('.');
  return [...sorted.filter((item) => !dotted(item)), ...sorted.filter(dotted)];
};

export const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;
